export default __webpack_public_path__ + "static/media/oedusantana_siteconversao.84e65784.svg";